function webDavOpen(webdavUrl) {
    let activeX = null;
    try {
        activeX = new ActiveXObject('SharePoint.OpenDocuments.3');
        if (activeX === null) {
            activeX = new ActiveXObject('SharePoint.OpenDocuments.2');
        }
        if (activeX === null) {
            activeX = new ActiveXObject('SharePoint.OpenDocuments.1');
        }
    } catch (e) {
    }

    const errorMessage = 'Nelze otevřít dokument';

    if (activeX !== null) {
        if (!activeX.EditDocument2(window, webdavUrl)) {
            try {
                console.error(errorMessage + ' ' + webdavUrl);
            } catch (e) {
            }
            return false;
        }
    } else {
        //Chrome 42 definitivně zakazalo NSAPI, tedy pluginy včetně Office webdav pluginu.
        //Naštestí podporuje 'aplikační protokoly'. Protokoly i plugin fungovaly v Chrome od verze Office 2010,
        //takže zádné omezení oproti pluginu by neměli nastat.
        //Tento způsob by fungoval by i pro IE, ale přestaly by fungovat Office 2007, kde funguje pouze ActiveX.

        const url = webdavUrl.split('.');
        let openUrl;

        const extension = url && url.length > 0 ? url[url.length - 1].toLowerCase() : null;
        switch (extension) {
            case 'rtf':
            case 'doc':
            case 'docx':
                openUrl = 'ms-word:ofe|u|' + webdavUrl;
                break;
            case 'xls':
            case 'xlsx':
                openUrl = 'ms-excel:ofe|u|' + webdavUrl;
                break;
            case 'ppt':
            case 'pptx':
                openUrl = 'ms-powerpoint:ofe|u|' + webdavUrl;
                break;
            default:
                console.warn("Nepodporavý typ pro webdav:" + extension);
                return false;
        }

        window.location = openUrl;
        return true;

    }
    return true;
}
export default webDavOpen;
